import type { WosIconProps } from 'types/common_types';

// generic icons
import close from './close';
import questionCircle from './questionCircle';

// catalog icons
import acrylicPrints from './acrylicPrints';
import canvas from './canvas';
import cards from './cards';
import clusters from './clusters';
import collagewall from './collagewall';
import custom from './custom';
import dreamPrints from './dreamPrints';
import fineArt from './fineArt';
import framedPrints from './framedPrints';
import metalPrints from './metalPrints';
import photoGifts from './photoGifts';
import photoPrints from './photoPrints';
import standout from './standout';
import thinWraps from './thinWraps';
import woodPrints from './woodPrints';
import xpozer from './xpozer';

// UI Features
import arrangements from './arrangements';
import arrangementsSave from './arrangements_save';
import arrangementsAdd from './arrangements_add';
import arrangementsRemove from './arrangements_remove';
import rooms from './rooms';
import signIn from './signIn';
import wallPreview from './wall_preview_icon';
import wallPreviewSaved from './wall_preview_icon_saved';
import wallPreviewShare from './wall_preview_icon_share';
import wallPreviewClose from './wall_preview_icon_close';

type IconComponentMap = {
  close: (props: WosIconProps) => JSX.Element;
  questionCircle: (props: WosIconProps) => JSX.Element;
  acrylicPrints: (props: WosIconProps) => JSX.Element;
  canvas: (props: WosIconProps) => JSX.Element;
  cards: (props: WosIconProps) => JSX.Element;
  clusters: (props: WosIconProps) => JSX.Element;
  collagewall: (props: WosIconProps) => JSX.Element;
  custom: (props: WosIconProps) => JSX.Element;
  dreamPrints: (props: WosIconProps) => JSX.Element;
  fineArt: (props: WosIconProps) => JSX.Element;
  framedPrints: (props: WosIconProps) => JSX.Element;
  metalPrints: (props: WosIconProps) => JSX.Element;
  photoGifts: (props: WosIconProps) => JSX.Element;
  photoPrints: (props: WosIconProps) => JSX.Element;
  standout: (props: WosIconProps) => JSX.Element;
  thinWraps: (props: WosIconProps) => JSX.Element;
  woodPrints: (props: WosIconProps) => JSX.Element;
  xpozer: (props: WosIconProps) => JSX.Element;
  arrangements: (props: WosIconProps) => JSX.Element;
  arrangementsSave: (props: WosIconProps) => JSX.Element;
  arrangementsAdd: (props: WosIconProps) => JSX.Element;
  arrangementsRemove: (props: WosIconProps) => JSX.Element;
  rooms: (props: WosIconProps) => JSX.Element;
  signIn: (props: WosIconProps) => JSX.Element;
  wallPreview: (props: WosIconProps) => JSX.Element;
  wallPreviewSaved: (props: WosIconProps) => JSX.Element;
  wallPreviewShare: (props: WosIconProps) => JSX.Element;
  wallPreviewClose: (props: WosIconProps) => JSX.Element;
};

const icons: IconComponentMap = {
  close,
  questionCircle,
  acrylicPrints,
  canvas,
  cards,
  clusters,
  collagewall,
  custom,
  dreamPrints,
  fineArt,
  framedPrints,
  metalPrints,
  photoGifts,
  photoPrints,
  standout,
  thinWraps,
  woodPrints,
  xpozer,
  arrangements,
  arrangementsSave,
  arrangementsAdd,
  arrangementsRemove,
  rooms,
  signIn,
  wallPreview,
  wallPreviewSaved,
  wallPreviewShare,
  wallPreviewClose,
};

export default icons;
